import { AnatomicalSystemContentModel } from './anatomicalSystemContentModel';

export class AnatomicalSystemModel {
  public anatomicalSystemId: number;
  public anatomicalSystemName: string;
  public levelNo: number;
  public orderNo: number;
  public anatomicalSystemTypeId: number;
  public parentId: number;
  public hasChildren: boolean;
  public anatomicalSystemContent: Array<AnatomicalSystemContentModel>
}